import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import FadeInSection from '@/components/base/FadeInSection';

const featuredSlugs = [
  'diyibanzhu-zhize-quanmian-jiexi',
  'diyibanzhu-quanxian-tixi-xiangjie',
  'diyibanzhu-renming-biaozhun-yu-liucheng',
  'shequ-neirong-guanli-shiyong-jiqiao',
  'cong-putong-banzhu-dao-diyibanzhu',
  'shequ-wenhua-jianshe-celve',
];

const articleImages: Record<string, string> = {
  'diyibanzhu-zhize-quanmian-jiexi': 'https://readdy.ai/api/search-image?query=Professional%20minimalist%20office%20workspace%20with%20warm%20lighting%20and%20clean%20composition%2C%20modern%20tech%20aesthetic%2C%20soft%20cream%20and%20beige%20tones%2C%20abstract%20geometric%20elements%2C%20editorial%20style%20photography&width=800&height=400&seq=article-zhize-01&orientation=landscape',
  'diyibanzhu-quanxian-tixi-xiangjie': 'https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20shield%20icon%20concept%2C%20warm%20beige%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20professional%20photography%2C%20abstract%20security%20theme&width=800&height=400&seq=article-quanxian-01&orientation=landscape',
  'diyibanzhu-renming-biaozhun-yu-liucheng': 'https://readdy.ai/api/search-image?query=Modern%20office%20with%20certificate%20and%20checklist%20concept%2C%20warm%20cream%20tones%2C%20professional%20atmosphere%2C%20clean%20minimalist%20composition%2C%20soft%20natural%20light%2C%20editorial%20style&width=800&height=400&seq=article-renming-01&orientation=landscape',
  'shequ-neirong-guanli-shiyong-jiqiao': 'https://readdy.ai/api/search-image?query=Organized%20desk%20with%20documents%20and%20laptop%2C%20warm%20beige%20background%2C%20modern%20minimalist%20workspace%2C%20soft%20lighting%2C%20professional%20editorial%20style%2C%20clean%20composition&width=800&height=400&seq=article-neirong-01&orientation=landscape',
  'cong-putong-banzhu-dao-diyibanzhu': 'https://readdy.ai/api/search-image?query=Career%20growth%20staircase%20concept%2C%20warm%20golden%20tones%2C%20minimalist%20professional%20atmosphere%2C%20clean%20geometric%20design%2C%20soft%20natural%20lighting%2C%20editorial%20photography&width=800&height=400&seq=article-jinsheng-01&orientation=landscape',
  'shequ-wenhua-jianshe-celve': 'https://readdy.ai/api/search-image?query=Community%20gathering%20abstract%20concept%20with%20connected%20circles%2C%20warm%20cream%20background%2C%20modern%20minimalist%20design%2C%20soft%20lighting%2C%20harmonious%20composition%2C%20editorial%20style&width=800&height=400&seq=article-wenhua-01&orientation=landscape',
};

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => featuredSlugs.includes(a.slug));

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <FadeInSection>
          <div className="flex items-center justify-between mb-10 md:mb-14">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                精选文章
              </h2>
              <p className="text-sm text-foreground-500">
                最受关注的第一版主管理知识
              </p>
            </div>
            <Link
              to="/category/guanli-jiqiao"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </FadeInSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {featuredArticles.map((article, index) => (
            <FadeInSection key={article.slug} delay={index * 100}>
              <Link
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer block"
              >
                <div className="relative w-full h-44 overflow-hidden">
                  <img
                    src={articleImages[article.slug]}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    {article.tags.slice(0, 2).map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <span>{article.date}</span>
                    <span>{article.readTime} 分钟阅读</span>
                  </div>
                </div>
              </Link>
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
}